import { useNavigate } from 'react-router-dom';

import BackButtonImage from '../../assets/back-button.png';
import Styles from './BackButton.module.css';

const BackButton = ({ destination }) => {
  const navigate = useNavigate();

  const handleBack = (destination) => {
    if (destination) {
      navigate(`/${destination}`);
    } else {
      navigate('/');
    }
  };

  return (
    <div className={Styles.backButtonContainer}>
      <button
        className={Styles.backButton}
        onClick={() => handleBack(destination)}
      >
        <img src={BackButtonImage} alt="Back button" />
      </button>
    </div>
  );
};

export default BackButton;
